'use client';

import { selectedCustomSlotAtom, selectedZonesAtom, surveyAtom } from '@/atom/survey';
import { useAtom } from 'jotai';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { insertSurveyEntryPoint } from '@/utils/actions';

export default function SurveyStartBottomButton() {
  const [survey, setSurvey] = useAtom(surveyAtom);
  const [selectedZones, setSelectedZones] = useAtom(selectedZonesAtom);
  const [selectedCustomSlot, setSelectedCustomSlot] = useAtom(selectedCustomSlotAtom);
  const pathname = usePathname();

  const handleClick = () => {
    let entryPoint = 'MAIN';
    if (pathname.includes('savedPois')) {
      entryPoint = 'MAIN-SAVEDPOIS';
    } else if (pathname.includes('myTravels')) {
      entryPoint = 'MAIN-MYTRAVELS';
    }

    insertSurveyEntryPoint(entryPoint);
    window.sessionStorage.removeItem('preparedZoneFromTravelCard');
    window.sessionStorage.removeItem('preparedPoiIdForSurvey');
    window.sessionStorage.removeItem('allthattravel_survey');
    setSurvey({
      fromDateTime: undefined,
      toDateTime: undefined,
      companion: undefined,
      zones: [],
      customSlots: [],
      departurePoint: undefined,
    });
    setSelectedZones({ zones: [], details: [] });
    setSelectedCustomSlot([]);
  };

  return (
    <div className='max-w-480pxr w-full fixed bottom-0 z-[2] bg-white h-100pxr px-20pxr pt-16pxr pb-32pxr'>
      <Link href='/survey/when' scroll={false} prefetch={false} onClick={handleClick}>
        <div className='w-full bg-new-point-500 rounded-8pxr text-center text-white body-16-md flex justify-center items-center h-50pxr'>
          새 일정표 만들기
        </div>
      </Link>
    </div>
  );
}
